import React, { useEffect, useRef } from 'react'

interface CartStepsProps {
  currentStep?: number
  onStepClick?: (step: number) => void
}

export const CartSteps: React.FC<CartStepsProps> = ({ currentStep = 1, onStepClick }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const steps = [
    { number: 1, text: 'Resumo', isActive: currentStep === 1 },
    { number: 2, text: 'Endereço', isActive: currentStep === 2 },
    { number: 3, text: 'Escolha de Pagamento', isActive: currentStep === 3 },
    { number: 4, text: 'Finalização', isActive: currentStep === 4 }
  ]

  const handleStepClick = (stepNumber: number) => {
    if (stepNumber <= currentStep && onStepClick) {
      onStepClick(stepNumber)
    }
  }

  // No mobile, mostra apenas o step atual
  const currentStepData = steps.find(step => step.number === currentStep)

  return (
    <>
      {/* Mobile: Mostra apenas o step atual */}
      <div className="flex items-center sm:hidden">
        {currentStepData && (
          <div className="flex items-center space-x-3 px-4">
            <div className="flex h-6 w-6 items-center justify-center rounded-full bg-neutral-100 text-sm font-semibold text-neutral-800">
              {currentStepData.number}
            </div>
            <span className="font-sans text-sm font-bold text-gray-700">
              {currentStepData.text}
            </span>
          </div>
        )}
      </div>

      {/* Desktop: Mostra todos os steps */}
      <div 
        ref={containerRef}
        className="hidden items-center space-x-8 sm:flex"
      >
        {steps.map((step, index) => (
          <div
            key={step.number}
            data-step={step.number}
            className={`flex items-center space-x-3 ${
              step.number <= currentStep
                ? 'cursor-pointer transition-opacity hover:opacity-80'
                : 'cursor-not-allowed opacity-50'
            }`}
            onClick={() => handleStepClick(step.number)}>
            <div
              className={`flex h-6 w-6 items-center justify-center rounded-full text-sm font-semibold ${
                step.isActive ? 'bg-neutral-100 text-neutral-800' : 'bg-neutral-100 text-neutral-400'
              }`}>
              {step.number}
            </div>

            <span className={`font-sans text-sm ${step.isActive ? 'font-bold text-gray-700' : 'font-normal text-gray-400'}`}>
              {step.text}
            </span>
          </div>
        ))}
      </div>
    </>
  )
}
